import { getState } from '~shared/utils/state';

/**
 * Returns the banners_enabled config key to enable/disable
 * displaying the banners component.
 *
 * @returns {Boolean} The flag (defaults to false if site_config key is missing)
 */
export function getBannersEnabled() {
    return getState('banners:enabled');
}

/**
 * Returns the jitter value (seconds) for Racing Widgets
 *
 * @returns {Integer} Jitter value (defaults to 0 if the key is missing)
 */
export function getRacingWidgetJitter() {
    return getState('racingwidget:jitter') || 0;
}

/**
 * Returns StatsCenter iframe info
 *
 * @returns {Object} StatsCenter iframe object
 */
export const getStatsCenterIframeInfo = () => {
    const statsCentreConfig = getState('statscenter');
    if (!statsCentreConfig || !statsCentreConfig.enabled) {
        return {};
    }

    return statsCentreConfig;
};

/**
 * Returns Sportcaller iframe info
 *
 * @returns {Object} StatsCenter iframe object
 */
 export const getSportcallerIframeInfo = () => getState('sportcaller') || {};

 /**
 * Returns competition only sport slugs
 *
 * @returns {Array} A list of competition only sport slugs
 */
  export const getCompetitionOnlySlugs = () => getState('competitions_only_sport_slugs') || [];

/**
 * Returns grouping only sport slugs
 *
 * @returns {Array} A list of grouping only sport slugs
 */
    export const getMultiGroupedOnlySlugs = () => getState('grouping_only_sport_slugs') || [];
